import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { BaseService } from 'src/app/core/services/base.service';
import { TokenService } from 'src/app/core/services/token.service';

@Injectable()
export class NavigationService extends BaseService {
    public hostName: string;

    constructor(private http: HttpClient, private tokenService: TokenService) {
        super();
    }

    /**
     * getMenuHeader() - Buscar menu horizontal (header)
     *
     */
    getMenuHeader(): Observable<any> {
        // Instacia o body através de BaseSerive.setBody();
        let body = this.setBody();

        let response = this.http
            .post(this.urlService + this.routeAdress.route_menu_header, body.toString())
            .pipe(map(this.extractData), catchError(this.serviceError));

        return response;
    }

    /**
     * getMenuFooter() - Buscar menu vertical (footer)
     *
     */
    getMenuFooter(): Observable<any> {
        // Instacia o body através de BaseSerive.setBody();
        let body = this.setBody();

        let response = this.http
            .post(this.urlService + this.routeAdress.route_menu_footer, body.toString())
            .pipe(map(this.extractData), catchError(this.serviceError));

        return response;
    }

    /**
     * getSocialMenu() - Buscar menu social (header)
     *
     */
    getSocialMenu(): Observable<any> {
        // Instacia o body através de BaseSerive.setBody();
        let body = this.setBody();

        let response = this.http
            .post(this.urlService + this.routeAdress.route_menu_social, body.toString())
            .pipe(map(this.extractData), catchError(this.serviceError));

        return response;
    }

    getPartnersCertifications() {
        const body = this.setBody();

        const response = this.http
            .post(this.urlService + this.routeAdress.route_partners_certification, body.toString())
            .pipe(map(this.extractData), catchError(this.serviceError));

        return response;
    }

    /**
     * search() - Realiza uma busca no sistema
     * @param keyword: string
     */
    search(keywords) {
        // Instacia o body através de BaseSerive.setBody();
        let body = this.setBody();

        body.set('keywords', keywords);

        let response = this.http
            .post(this.urlService + this.routeAdress.route_search, body.toString())
            .pipe(map(this.extractData), catchError(this.serviceError));

        return response;
    }
}
